import React from 'react';
import { generate_aes_key } from 'utils/crypto';
import HOST_API from 'constants/HOST_API';
import useFetch from './useFetch';

export default function useRsaKey(props) {
  const onRequest = useFetch(HOST_API, 'sso/key');

  const requestRsaKey = React.useCallback((id, uuid, callback) => {
    const onReceive = (res) => {
      if (+res.res_code === 200) {
        const {
          hash,
          key,
          timestamp,
        } = res?.data || {};
        const data = {
          hash,
          key,
          timestamp,
          aes: generate_aes_key(32),
          iv: generate_aes_key(16),
        };
        callback && callback(true, data);
      } else {
        callback && callback(false, { type: 'onReceive', message: res?.res_msg, extra: res });
      }
    };
    const onCatch = (err) => {
      callback && callback(false, { type: 'onCatch', messgae: '문제가 발생했습니다.', extra: err });
    };
    const onExpire = (abort) => {
      abort('Timeout');
      callback && callback(false, { type: 'onExpire', message: '서버와 연결할 수 없습니다.', extra: abort });
      return true;
    };

    onRequest({
      parameters: {
        id
      },
      timeout: 6000,
      events: {
        onReceive,
        onExpire,
        onCatch,
      },
      uuid,
    });
  }, [onRequest]);


  return {
    requestRsaKey,
  };
}
